import { DialogComponent } from '@theme/dialog';

class ShotcrimpFilm extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    this.filmController?.abort();
    this.filmController = new AbortController();
    this.addEventListener('dialog:close', () => this.querySelector('video')?.pause(), { signal: this.filmController.signal });
  }

  showDialog() {
    const target = this.querySelector('[data-film-player]');
    const template = this.querySelector('[data-film-template]');
    if (target && template && !target.querySelector('video')) target.append(template.content.cloneNode(true));
    super.showDialog();
  }

  disconnectedCallback() {
    this.filmController?.abort();
    this.querySelector('video')?.pause();
    super.disconnectedCallback();
  }
}

if (!customElements.get('shotcrimp-film')) customElements.define('shotcrimp-film', ShotcrimpFilm);

